import React, { useEffect } from "react";
import {
  Modal,
  Typography,
  Table,
  Card,
  Row,
  Col,
  Button,
  message,
} from "antd";
import axios from "axios"; // Import axios or any other HTTP client

const { Title, Text } = Typography;

const OrderDetailsModal = ({ visible, order, vendorId, onCancel }) => {
  const [modalWidth, setModalWidth] = React.useState(1200); // Adjust modal width as needed
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);

  console.log(vendorId);
  // Define rowSelection object
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const columns = [
    {
      title: "Order Id",
      dataIndex: "order_id",
      key: "order_id",
    },
    {
      title: "Date and Time",
      dataIndex: "order_date",
      key: "order_date",
    },
    {
      title: "Total",
      dataIndex: "sub_total",
      key: "sub_total",
      render: (text) => `${text}`,
    },
    {
      title: "Delivery Charge",
      dataIndex: "delivery_charge",
      key: "delivery_charge",
      render: (text) => `${text}`,
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      key: "payment_method",
      render: (text) => `${text}`,
    },
    {
      title: "Cod Charge",
      dataIndex: "cod_charge",
      key: "cod_charge",
      render: (text) => `${text}`,
    },
    {
      title: "Aptope Commission",
      dataIndex: "Aptope_commission",
      key: "Aptope_commission",
      render: (text) => `${text}`,
    },
    {
      title: "GST",
      dataIndex: "gst",
      key: "gst",
      render: (text) => `${text}`,
    },
    {
      title: "Earnings",
      dataIndex: "total_earnings",
      key: "total_earnings",
      render: (text) => `${text}`,
    },
  ];

  const handleSettle = async () => {
    try {
      console.log("------->", "vendorId");

      // Collect the selected row data
      const selectedRows = order.filter((row) =>
        selectedRowKeys.includes(row.order_id)
      );

      // Construct the data to be sent to the API
      const ordersdata = selectedRows.map((row) => ({
        order_id: row.order_id,
        vendor_id: vendorId,
      }));

      console.log("dataToSend", ordersdata);

      // Send the data to your API endpoint
      await axios.post("https://app-tl2d3sc25q-uc.a.run.app/api/commission_settled", {
        orders: ordersdata,
      });

      // Notify the user
      message.success("Orders settled successfully!");

      // Optionally: Clear selection and close modal or perform other actions
      setSelectedRowKeys([]);
      onCancel(); // Close the modal if required
    } catch (error) {
      console.error("Error settling orders:", error);
      message.error("Failed to settle orders. Please try again.");
    }
  };

  return (
    <Modal
      title=""
      visible={visible}
      onCancel={onCancel}
      width={modalWidth}
      footer={null} // No footer buttons
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card title="Vendor Commission" bordered={false}>
            <Row justify="end" style={{ marginBottom: 16 }}>
              <Col>
                <Button
                  type="primary"
                  onClick={handleSettle}
                  disabled={selectedRowKeys.length === 0}
                >
                  Settle
                </Button>
              </Col>
            </Row>
            <Table
              columns={columns}
              dataSource={order}
              rowKey="order_id"
              rowSelection={rowSelection} // Apply row selection
            />
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export default OrderDetailsModal;
